module.exports = __webpack_public_path__ + "static/image/history/pc/201803.jpg?f299f3dd";